import "./teacherManage.css";

import { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import TabTickets from "./TabTickets";
import Tabs from "../../components/Tabs";
import TeacherRating from "./TeacherRating";
import ReportTeacher from "./ReportTeacher";
import TabManageTeacher from "./TabManageTeacher";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import teacherIcon from "../../assets/images/icons/icon_teacher_header.svg";

import { Manage } from "./Styles";

function NewTeacher() {
  const { t } = useTranslation();
  const { detailTeacher } = useSelector((state) => state.companyManagerReducer);

  const [activeTab, setActiveTab] = useState("PERSONAL_INFO");

  const option = ["PERSONAL_INFO"];
  const options = ["PERSONAL_INFO", "TICKETS", "REPORT"];

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header t={t} title={t("ITEM_TEACHERS")} icon={<img src={teacherIcon} alt="teacherIcon" />} typeIcon="custom" />

        <div className="content">
          {window.location.pathname === "/teachers/new" ? (
            <Manage>
              <Tabs options={option} activeTab={activeTab} setActiveTab={setActiveTab}>
                <TabManageTeacher />
              </Tabs>
            </Manage>
          ) : (
            <>
              <TeacherRating />
              <Manage>
                <Tabs options={options} activeTab={activeTab} setActiveTab={setActiveTab}>
                  {options[0] === activeTab && <TabManageTeacher detailTeacher={detailTeacher} />}
                  {options[1] === activeTab && <TabTickets id={detailTeacher.id} />}
                  {options[2] === activeTab && <ReportTeacher teacherId={detailTeacher.teacherId} />}
                </Tabs>
              </Manage>
            </>
          )}
        </div>
      </section>
    </div>
  );
}

export default NewTeacher;
